import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgIcon } from '@ng-icons/core';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [NgIcon],
  templateUrl: './confirmation-modal.component.html',
  styleUrl: './confirmation-modal.component.scss'
})
export class ConfirmationModalComponent {
  @Input() title = 'Confirm';
  @Input() message = 'Are you sure you want to proceed?';
  @Input() confirmButtonText = 'Ok';
  @Input() cancelButtonText = 'Cancel';
  @Input() isReversible: boolean = false;  // Reversibility check
  @Input() type: 'default' | 'danger' = 'default';

  constructor(public activeModal: NgbActiveModal) { }

  confirm() {
    this.activeModal.close(true);
  }

  cancel() {
    this.activeModal.dismiss(false);
  }
}
